/**
 * 今日到店模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 优惠券审核列表 GET /api/v1/coupon/coupon_reviews
Mock.mock(/coupon\/coupon_reviews/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'coupon_reviews|10': [{
      'applicant': '@word',
      'customer': '@word',
      'customer_mobile': '1591403885',
      'face_value': 11100,
      'id|+1': 1,
      'num': 2,
      'plate_number': '粤A@Integer(5,5)', // 可能为空
      'reason': '@word',
      'status': 1,
      'submit_at': '2017-09-28 12:14:44',
      'title': '保养抵扣券'
    }],
    'total_num': 22
  }
})
